import { render } from "./KpiSave.vue?vue&type=template&id=2dfcf081&scoped=true"
import script from "./KpiSave.vue?vue&type=script&lang=js"
export * from "./KpiSave.vue?vue&type=script&lang=js"

import "./kpi.scss?vue&type=style&index=0&id=2dfcf081&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfcf081"]])

export default __exports__